import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { defaultMemoize } from 'reselect';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Popover from '../popover/TPopover';
import PopoverContent from '../PopoverContent';
import 'tstyles/component.scss';
export default function withCellPopover(Component) {
  var _class;
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'focus';
  return _class = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(_withCellPopover, _React$PureComponent);
    var _super = _createSuper(_withCellPopover);
    function _withCellPopover() {
      var _this;
      _classCallCheck(this, _withCellPopover);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "getPopoverContent", defaultMemoize(function (popoverMessage, messageType) {
        return !popoverMessage ? null : /*#__PURE__*/React.createElement(PopoverContent, {
          message: popoverMessage,
          messageType: messageType
        });
      }));
      return _this;
    }
    _createClass(_withCellPopover, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          error = _this$props.error,
          warning = _this$props.warning,
          autoAdjustOverflow = _this$props.autoAdjustOverflow,
          info = _this$props.info,
          getPopoverComponentKey = _this$props.getPopoverComponentKey,
          overlayClassName = _this$props.overlayClassName,
          popoverPlacement = _this$props.popoverPlacement;
        var popoverMessage = error || warning || info;
        var messageType = error && 'error' || warning && 'warning' || info && 'info';
        return /*#__PURE__*/React.createElement(Popover, {
          overlayClassName: overlayClassName,
          placement: popoverPlacement,
          autoAdjustOverflow: autoAdjustOverflow,
          content: this.getPopoverContent(popoverMessage, messageType),
          trigger: trigger
        }, /*#__PURE__*/React.createElement(Component, _extends({
          key: getPopoverComponentKey(this.props),
          hasError: !!error
        }, this.props)));
      }
    }]);
    return _withCellPopover;
  }(React.PureComponent), _defineProperty(_class, "propTypes", {
    error: PropTypes.string,
    warning: PropTypes.string,
    info: PropTypes.string,
    children: PropTypes.node,
    autoAdjustOverflow: PropTypes.bool,
    getPopoverComponentKey: PropTypes.func,
    overlayClassName: PropTypes.string,
    popoverPlacement: PropTypes.string
  }), _defineProperty(_class, "defaultProps", {
    error: EMPTY_STRING,
    warning: EMPTY_STRING,
    info: EMPTY_STRING,
    children: null,
    autoAdjustOverflow: true,
    getPopoverComponentKey: _noop,
    overlayClassName: undefined,
    popoverPlacement: 'top'
  }), _class;
}